module.exports = __webpack_public_path__ + "media/images/misc/modal-gloss-19c73bcb8bc0bbb1b30397129c0e5a0e92cb0227313f05354f15a5824338fe73.png";